// Crimson Sci-Fi Theme Configuration
// Dark, edgy, cyberpunk aesthetic

export const crimsonTheme = {
  name: 'crimson',
  displayName: 'Crimson Sci-Fi',
  
  colors: {
    // Primary palette
    primary: '#DC143C',        // Crimson red
    primaryHover: '#B91030',   // Darker crimson
    primaryLight: '#FF4466',   // Light crimson
    
    secondary: '#9333EA',      // Purple
    secondaryHover: '#7C28C7', // Darker purple
    secondaryLight: '#B47FFF', // Light purple
    
    accent: '#00D9FF',         // Cyan
    accentHover: '#00B8DB',    // Darker cyan
    
    // Backgrounds
    background: '#0A0A0F',     // Very dark blue
    backgroundAlt: '#131318',  // Dark gray-blue
    backgroundDark: '#050508', // Almost black
    
    // Text
    textPrimary: '#FFFFFF',    // White
    textSecondary: '#B4B4C8',  // Light gray-blue
    textLight: '#7A7A8E',      // Medium gray
    textInverse: '#0A0A0F',    // Dark (for light backgrounds)
    
    // States
    success: '#10B981',        // Green
    warning: '#F59E0B',        // Orange
    error: '#EF4444',          // Red
    info: '#3B82F6',           // Blue
    
    // Shadows
    shadowPrimary: 'rgba(220, 20, 60, 0.3)',
    shadowSecondary: 'rgba(147, 51, 234, 0.2)',
    shadowDark: 'rgba(0, 0, 0, 0.5)',
  },
  
  typography: {
    fontDisplay: '"Unbounded", sans-serif',
    fontBody: '"Outfit", sans-serif',
    fontAccent: '"Unbounded", sans-serif',
    fontCode: '"JetBrains Mono", monospace',
    
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '3.75rem',
    },
    
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
    },
  },
  
  spacing: {
    containerPadding: '1.5rem',
    sectionGap: '5rem',
    cardGap: '1.5rem',
  },
  
  borderRadius: {
    sm: '6px',
    md: '10px',
    lg: '16px',
    xl: '24px',
    full: '9999px',
  },
  
  shadows: {
    sm: '0 2px 8px var(--shadow-dark)',
    md: '0 4px 16px var(--shadow-dark)',
    lg: '0 8px 32px var(--shadow-dark)',
    colored: '0 8px 24px var(--shadow-primary)',
    glow: '0 0 30px var(--shadow-primary)',
  },
  
  animations: {
    duration: {
      fast: '200ms',
      normal: '400ms',
      slow: '600ms',
    },
    easing: {
      default: 'cubic-bezier(0.4, 0, 0.2, 1)',
      bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
      smooth: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    },
  },
  
  layout: {
    maxWidth: '1400px',
    headerHeight: '80px',
    footerHeight: '320px',
  },
};

export default crimsonTheme;
